import { SceneBlindState } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionBlind',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionBlind extends SceneActionGeneral {
  SceneBlindState = SceneBlindState;

  get isConfirmEnabled() {
    return true;
  }
}
